import React, {useState,useEffect} from "react";
import Swal from "sweetalert2";
import {useParams, useSearchParams} from "react-router-dom"
import moment from 'moment';
import { NumericFormat } from 'react-number-format';

// SERVICES
import authService from "../../services/authService";


const errorDetail = (error) =>
    error?.response?.data?.errors?.[0]?.detail || 'No se pudo completar la solicitud. Intente nuevamente.';

const showError = (text) => Swal.fire({
    title: 'ERROR',
    text,
    icon: 'error',
    confirmButtonText: 'OK',
    confirmButtonColor: '#f13939'
});

const toArray = (data) => Array.isArray(data) ? data : (data ? [data] : []);

function PublicAuthorization() {

    // Tokens por query string (?ope=...&fund=...). Legacy: /:opeToken/:fundToken
    const params = useParams();
    const [searchParams] = useSearchParams();
    const opeToken = (searchParams.get('ope') || params.opeToken || '').trim();
    const fundToken = (searchParams.get('fund') || params.fundToken || '').trim();

    const [loading, setLoading] = useState(true)
    const [authorizing, setAuthorizing] = useState(false)
    const [invalidLink, setInvalidLink] = useState(false)
    const [header, setHeader] = useState({})
    const [opeCollection, setOpeCollection] = useState([])
    const [fundCollection, setFundCollection] = useState([])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { doLoad(); }, []);

    const doLoad = async () => {
        // Sin ningún token el enlace no sirve; con al menos uno se opera con ese
        if (!opeToken && !fundToken) {
            setInvalidLink(true);
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            if (opeToken) {
                const response = await authService.getOperationDetailById(opeToken);
                const opeData = toArray(response.data);
                setOpeCollection(opeData);
                if (opeData.length > 0) {
                    setHeader({account: opeData[0].comitente_numero, account_name: opeData[0].comitente_descripcion});
                }
            }
            if (fundToken) {
                const response = await authService.getOperationFundsById(fundToken);
                setFundCollection(toArray(response.data));
            }
        } catch (error) {
            setInvalidLink(true);
            showError(errorDetail(error));
        } finally {
            setLoading(false);
        }
    }

    const doAuthorize = async () => {
        Swal.fire({
            title: "Atención!",
            text: "Ud. esta seguro que quiere AUTORIZAR las operaciones detalladas ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Autorizo",
            confirmButtonColor: "#83766d"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setAuthorizing(true);
                    var data = {
                        esco_operation_detail_id: opeToken || null,
                        fund_operation_id: fundToken || null
                    }
                    await authService.setOperationDetailSign(data);
                    setOpeCollection([]);
                    setFundCollection([]);
                } catch (error) {
                    showError(errorDetail(error));
                } finally {
                    setAuthorizing(false);
                }
            }
        });
    }

    const hasCollections = opeCollection.length > 0 || fundCollection.length > 0;

    return (
        
        <div className="container-fluid flex-grow-1 container-p-y">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-center">
                        <img src="/alchemy-logo.svg" alt="alchemy valores logo" className="img-fluid mb-4" style={{width: '15%'}}/>
                    </div>
                    {
                        loading ? (
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                { invalidLink ? (
                                    <h4 className="text-center mb-4">El enlace no es válido o ha expirado. Por favor, comuníquese con Alchemy Valores.</h4>
                                ) : hasCollections ? (
                                    <>
                                        <h2 className="card-title mb-4">{header.account} - {header.account_name}</h2>
                                        <p className="card-text">Se detallan a continuación operaciones por las que se solicita su aprobación.</p>

                                        { opeCollection.length > 0 &&
                                            <>
                                                <h4 className="text-start mt-4 mb-3"><strong>Autorizaciones Operaciones</strong></h4>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr className="text-center">
                                                                <th>Fecha de Concertación</th>
                                                                <th>Moneda</th>
                                                                <th>Tipo Operación</th>
                                                                <th>Instrumento</th>
                                                                <th>Abreviatura</th>
                                                                <th>Fecha Liquidación</th>
                                                                <th>Cantidad</th>
                                                                <th>Precio</th>
                                                                <th>Bruto</th>
                                                                <th>Arancel(%)</th>
                                                                <th>Arancel</th>
                                                                <th>Derecho de Registro / Liquidación</th>
                                                                <th>Neto en Pesos</th>
                                                                <th>Neto en Dolares</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            { opeCollection.map((ope) => (
                                                                <tr key={ope.id} className="text-center">
                                                                    <td>{moment(ope.fecha_de_concertacion).format('DD/MM/YYYY')}</td>
                                                                    <td>{ope.moneda_descripcion}</td>
                                                                    <td>{ope.tipo_de_operacion_descripcion}</td>
                                                                    <td>{ope.instrumento_descripcion}</td>
                                                                    <td>{ope.instrumento_abreviatura}</td>
                                                                    <td>{moment(ope.fecha_de_liquidacion).format('DD/MM/YYYY')}</td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.cantidad} decimalScale={0} allowLeadingZeros thousandSeparator="." decimalSeparator="," />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.precio} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.bruto} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.arancel} decimalScale={4} allowLeadingZeros thousandSeparator="." decimalSeparator="," />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.arancel_importe} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.derecho_de_registro_liquidacion_importe} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.neto_en_pesos} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                    <td>
                                                                        <NumericFormat displayType="text" value={ope.neto_en_dolares} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," prefix={'$'} />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        }

                                        { fundCollection.length > 0 &&
                                            <>
                                                <h4 className="text-start mt-4 mb-3"><strong>Autorizaciones Operaciones FCI</strong></h4>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr className="text-center">
                                                                <th>Fecha</th>
                                                                <th>Nro.</th>
                                                                <th>Comitente</th>
                                                                <th>Tipo de Operación</th>
                                                                <th>Fondo</th>
                                                                <th>Moneda</th>
                                                                <th>Plazo</th>
                                                                <th>Tipo</th>
                                                                <th>Cantidad / Monto</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            { fundCollection.map((ope) => (
                                                                <tr key={ope.id} className="text-center">
                                                                    <td>{moment(ope.date).format('DD/MM/YYYY')}</td>
                                                                    <td>{ope.account}</td>
                                                                    <td>{ope.account_model.name}</td>
                                                                    <td>{ope.operation_type.name}</td>
                                                                    <td>{ope.fund.name}</td>
                                                                    <td>{ope.currency.name}</td>
                                                                    <td>{ope.settlement_term.name}</td>
                                                                    <td>{ope.investment_mode.name}</td>
                                                                    <td className="text-end">
                                                                        { ope.investment_mode_id === 1 &&
                                                                            <NumericFormat displayType="text" value={ope.amount} decimalScale={2} allowLeadingZeros thousandSeparator="." decimalSeparator="," />
                                                                        }
                                                                        { ope.investment_mode_id === 2 &&
                                                                            <NumericFormat displayType="text" value={ope.qty} decimalScale={0} allowLeadingZeros thousandSeparator="." decimalSeparator="," />
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        }

                                        <div className="d-flex justify-content-center mt-4">
                                            { authorizing ? (
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                <button type="button" className="btn btn-primary btn-lg" onClick={doAuthorize}>Autorizo</button>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <h4 className="text-center mb-4">Estimado cliente, sus operaciones ya se encuentran aprobadas. Muchas gracias.</h4>
                                )}
                            </>
                        )
                    }
                </div>
                {/* GLOBEMIND */}
                <footer style={{textAlign: 'right', marginRight: 20,fontSize: 'small', marginTop: '-25px'}}>
                    Power by <a href="https://globemind.com/" target="_blank" style={{color: '#396bad'}} rel="noreferrer" title="GlobeMind Software Distillery">GlobeMind</a>
                </footer>
            </div>

        </div>
      );
}


export default PublicAuthorization;